export const MP_ORG_SIGN_UP_DONE = 'org_sign_up_done';
export const MP_USER_DEMOGRAPHICS_ONBOARDING_DONE = 'user_demographics_done';
export const MP_USER_SIGN_UP_DONE = 'user_sign_up_done';
export const MP_SCREENER_START = 'screener_start';
export const MP_SCREENER_FINISH = 'screener_finish';
export const MP_MEMBER_CARE_CALL_SCHEDULED = 'member_care_call_scheduled';
export const MP_ADD_ORG_MEMBER = 'add_org_member';
export const MP_REINVITE_ORG_MEMBER = 'reinvite_org_member';
export const MP_REMOVE_ORG_MEMBER = 'remove_org_member';
export const MP_EULA_ACCEPTED = 'eula_accepted';
export const MP_UPGRADE_MEMBER_TO_PEER_SUPPORT = 'upgrade_member_to_peer_support';
export const MP_DOWNGRADE_PEER_SUPPORT_TO_MEMBER = 'downgrade_peer_support_to_member';

export const MP_PUBLIC_SCREENER_STARTED = 'public_screener_started';

// Oct 2nd 2025
export const MP_SCREENER_PAGE_VIEWED = 'Screener Page Viewed';
export const MP_SCREENER_ORG_URL_SUBMITTED = 'Organization URL Submitted'; // { org_url: string }
export const MP_SCREENER_QUESTION_ANSWERED = 'Question Answered'; //  { question_number: number, answer: string | boolean | value }
export const MP_SCREENER_EMAIL_SUBMITTED = 'Email Submitted'; // { email: string }
export const MP_SCREENER_COMPLETED = 'Screener Completed'; // { total_questions: number }
export const MP_SCREENER_RESULTS_VIEWED = 'Results Viewed';
export const MP_SCREENER_RESULTS_EMAILED = 'Results Emailed'; // { email: userEmail }

export const REGULAR_SCREENER_TYPE = 'regular_screener';
export const PUBLIC_SCREENER_TYPE = 'public_screener';

// Nov 29 2025 - alignment with Mobile app
export const MP_GOAL_CREATED = 'MYO Goal Created';
export const MP_GOAL_COMPLETED = 'MYO Goal Completed';
export const MP_GOAL_EDITED = 'MYO Goal Edited';

// 
export const MP_PEER_SUPPORT_CONTACTED_VIA_EMAIL = 'MYO Peer Support Contacted Via Email';
export const MP_PEER_SUPPORT_CONTACTED_VIA_TEXT = 'MYO Peer Support Contacted Via Text';
export const MP_PEER_SUPPORT_CONTACTED_VIA_PHONE = 'MYO Peer Support Contacted Via Phone';

export const mixpanelEvents = {
  ORG_SIGN_UP_DONE: MP_ORG_SIGN_UP_DONE,
  USER_DEMOGRAPHICS_ONBOARDING_DONE: MP_USER_DEMOGRAPHICS_ONBOARDING_DONE,
  USER_SIGN_UP_DONE: MP_USER_SIGN_UP_DONE,
  SCREENER_START: MP_SCREENER_START,
  SCREENER_FINISH: MP_SCREENER_FINISH,
  MEMBER_CARE_CALL_SCHEDULED: MP_MEMBER_CARE_CALL_SCHEDULED,
  ADD_ORG_MEMBER: MP_ADD_ORG_MEMBER,
  REINVITE_ORG_MEMBER: MP_REINVITE_ORG_MEMBER,
  REMOVE_ORG_MEMBER: MP_REMOVE_ORG_MEMBER,
  EULA_ACCEPTED: MP_EULA_ACCEPTED,
  UPGRADE_TO_PEER_SUPPORT: MP_UPGRADE_MEMBER_TO_PEER_SUPPORT,
  DOWNGRADE_PEER_SUPPORT_TO_MEMBER: MP_DOWNGRADE_PEER_SUPPORT_TO_MEMBER,

  PUBLIC_SCREENER_STARTED: MP_PUBLIC_SCREENER_STARTED,

  // Oct 2nd 2025
  SCREENER_PAGE_VIEWED: MP_SCREENER_PAGE_VIEWED,
  SCREENER_ORG_URL_SUBMITTED: MP_SCREENER_ORG_URL_SUBMITTED,
  SCREENER_QUESTION_ANSWERED: MP_SCREENER_QUESTION_ANSWERED,
  SCREENER_EMAIL_SUBMITTED: MP_SCREENER_EMAIL_SUBMITTED,
  SCREENER_COMPLETED: MP_SCREENER_COMPLETED,
  SCREENER_RESULTS_VIEWED: MP_SCREENER_RESULTS_VIEWED,
  SCREENER_RESULTS_EMAILED: MP_SCREENER_RESULTS_EMAILED,

  // Nov 29 2025 - alignment with Mobile app
  GOAL_CREATED: MP_GOAL_CREATED,
  GOAL_COMPLETED: MP_GOAL_COMPLETED,
  GOAL_EDITED: MP_GOAL_EDITED,

  // Dec 14 2025 - Peer Support event
  PEER_SUPPORT_CONTACTED_VIA_EMAIL: MP_PEER_SUPPORT_CONTACTED_VIA_EMAIL,
  PEER_SUPPORT_CONTACTED_VIA_TEXT: MP_PEER_SUPPORT_CONTACTED_VIA_TEXT,
  PEER_SUPPORT_CONTACTED_VIA_PHONE: MP_PEER_SUPPORT_CONTACTED_VIA_PHONE,
};
